var _a, _b;
var PAGES = {
    CREDITS_LANDING: 'creditsLanding',
    REFERRAL_VITRINS: 'referralVitrins',
};
var PAGE_NAMES = (_a = {},
    _a[PAGES.CREDITS_LANDING] = 'Лендинг подбора',
    _a[PAGES.REFERRAL_VITRINS] = 'Реферальная витрина',
    _a);
var EXTERNAL_URLS = (_b = {},
    _b[PAGES.CREDITS_LANDING] = ['/kredity/onlajn/', '/kredity/onlajn-zayavka-na-kredit/'],
    _b[PAGES.REFERRAL_VITRINS] = ['/kredity/'],
    _b);
var EVENT_TYPE = {
    CALCULATOR_MOUNT: 'CALCULATOR_MOUNT',
    CALCULATOR_PARAM_CHANGED: 'CALCULATOR_PARAM_CHANGED',
    CALCULATOR_PARAM_ERROR: 'CALCULATOR_PARAM_ERROR',
    CALCULATOR_REDIRECT_TO_FORM: 'CALCULATOR_REDIRECT_TO_FORM',
    CALCULATOR_BUTTON_CLICK: 'CALCULATOR_BUTTON_CLICK',
    CALCULATOR_AUTH_ERROR: 'CALCULATOR_AUTH_ERROR',
};

export { EVENT_TYPE, EXTERNAL_URLS, PAGES, PAGE_NAMES };
//# sourceMappingURL=constants.js.map
